import { useContext } from 'react'
import { GlobalTimezoneContext } from '../GlobalTimezoneContext'

export const useGlobalTimezone = () => useContext(GlobalTimezoneContext)
